import { REQUEST_POST_ACR_INFO_BOX_SUCCESS } from 'src/constants';
import {
  ACR_INFO_BOX_ACTION,
  POST_ACR_INFO_BOX_CONTENT_KEY,
  UPDATE_REVIEW_STATE_DATA_ACTION,
  UPDATE_REVIEW_STATE_DATA_KEY,
} from 'src/redux/constants';
import type { ViewAction, ViewActionPayload } from 'src/redux/viewState/types';

export const updateReviewData = (params: ViewActionPayload): ViewAction => {
  return {
    type: UPDATE_REVIEW_STATE_DATA_ACTION,
    dataKey: UPDATE_REVIEW_STATE_DATA_KEY,
    value: params,
  };
};

export const postAcrInfoBox = (params: ViewActionPayload): ViewAction => {
  return {
    type: ACR_INFO_BOX_ACTION,
    dataKey: POST_ACR_INFO_BOX_CONTENT_KEY,
    value: params,
  };
};

export const receivePostAcrInfoBoxSuccess = (payload, dataKey?) => {
  return {
    type: REQUEST_POST_ACR_INFO_BOX_SUCCESS,
    payload,
    dataKey,
  };
};
